
import { __ } from '@wordpress/i18n';
import { classNames } from 'primereact/utils';


// components
import LoginForm from './components/LoginForm';

const Login = () => {

    return (
        <div className={classNames(['appPage', 'appPageLogin'])}>
            <div className="appPageLogin__wrapper LoginForm">
                <div className='LoginForm_Wrapper'>
                  <h1>{__('Accedi', 'scan360')}</h1>
                    <LoginForm/>
                <div className="appPage__spacer"></div>  
                </div>
                

            </div>
        </div>
    )
}

export default Login;